import React from 'react';
import { 
  Typography, 
  Button
} from 'antd';
import { 
  PlusOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '@/components/Layouts/AdminLayout/AdminLayout';
import UnitTable from '@/components/admin/UnitTable';

const { Title } = Typography;

interface UnitData {
  id: string;
  type: string;
  name: string;
  registrant: string;
  registrationDate: string;
}

const AdminUnitList: React.FC = () => {
  const navigate = useNavigate();

  const handleAddUnit = () => {
    navigate('/admin/unit/register');
  };

  const handleViewDetail = (record: UnitData) => {
    navigate(`/admin/unit/${record.id}`);
  };

  return (
    <AdminLayout>
      <div style={{ padding: '24px' }}>
        {/* 헤더 */}
        <div style={{ marginBottom: '24px' }}>
          <Title level={2}>유닛 리스트</Title>
        </div>

        {/* 버튼 영역 */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '24px' }}>
          <Button 
            type="primary" 
            icon={<PlusOutlined />} 
            size="large"
            onClick={handleAddUnit}
          >
            유닛 등록
          </Button>
        </div>

        {/* 유닛 테이블 */}
        <UnitTable
          showCheckbox={false}
          showSearch={true}
          size="middle"
          onRowClick={handleViewDetail}
        />
      </div>
    </AdminLayout>
  );
};

export default AdminUnitList; 